export default __webpack_public_path__ + "static/zenith-2-c8bfcc6013032809b98057ad34a635d4.jpg";